import WrappedTelIcon from 'components/elements/icons/WrappedTelIcon'
import Text from 'components/elements/texts/Text'
import DOMAIN from 'constants/domains'
import React from 'react'
import styled from 'styled-components'
import { getDomain, isKsDomain ,isSaficDomain } from 'utils/domain'

import Button from './Button'

/**
 * 架電ボタン
 */
const ContactButton: React.FC = () => {
  const background = isKsDomain() ? 'var(--color-main)' : isSaficDomain() ? '#0000001F' :{
    [DOMAIN.SJ]: 'var(--color-main)',
  }[getDomain()]

  return (
    <StyledContactButton background={background}>
      <WrappedTelIcon />
      <TextArea>
        <Text color="var(--color-text-for-main-background)">
          ロードサービスに関する
        </Text>
        <Text color="var(--color-text-for-main-background)">
          お問い合わせはお電話ください。
        </Text>
      </TextArea>
    </StyledContactButton>
  )
}

const StyledContactButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 4px;
  text-align: left;
`

const TextArea = styled.div`
  flex: 1;
  margin-left: 10px;
`

export default ContactButton
